export default __webpack_public_path__ + "static/media/04.ee2c8e7d.jpg";